import { call } from "redux-saga/effects";
import { API_URLS } from "../../../config";
import { CallApi } from "./api/callApi";

export function* applyLeaveSaga(action) {
  try {
    const data = action.payload;
    const resp = yield call(CallApi.POST, API_URLS.USERS.LEAVES.ROUTE, data?.data, data?.token);
    if (resp && resp?.status && resp?.status >= 200 && resp?.status < 300 && resp?.data && resp?.data?.success) {
      action && action.callbackSuccess && action.callbackSuccess(resp?.data);
    } else {
      action && action.callbackError && action.callbackError(resp?.data);
    }
  } catch (e) {
    action && action.callbackError && action.callbackError(e && e?.data ? e?.data : e);
  }
}


export function* getLeavesSaga(action) {
  try {
    const data = action.payload;
    const resp = yield call(CallApi.GET, API_URLS.USERS.LEAVES.ROUTE, data?.data, data?.token);
    if (resp && resp?.status && resp?.status >= 200 && resp?.status < 300 && resp?.data && resp?.data?.success) {
      action && action.callbackSuccess && action.callbackSuccess(resp?.data);
    } else {
      action && action.callbackError && action.callbackError(resp?.data);
    }
  } catch (e) {
    action && action.callbackError && action.callbackError(e && e?.data ? e?.data : e);
  }
}


export function* getAllLeavesSaga(action) {
  try {
    const data = action.payload;
    const resp = yield call(CallApi.GET, API_URLS.USERS.LEAVES.ALL, data?.data, data?.token);
    if (resp && resp?.status && resp?.status >= 200 && resp?.status < 300 && resp?.data && resp?.data?.success) {
      action && action.callbackSuccess && action.callbackSuccess(resp?.data);
    } else {
      action && action.callbackError && action.callbackError(resp?.data);
    }
  } catch (e) {
    action && action.callbackError && action.callbackError(e && e?.data ? e?.data : e);
  }
}


export function* updateLeaveSaga(action) {
  try {
    const data = action.payload;
    const { id, ...d } = data?.data
    const resp = yield call(CallApi.PATCH, `${API_URLS.USERS.LEAVES.ROUTE}/${id}`, d, data?.token);
    if (resp && resp?.status && resp?.status >= 200 && resp?.status < 300 && resp?.data && resp?.data?.success) {
      action && action.callbackSuccess && action.callbackSuccess(resp?.data);
    } else {
      action && action.callbackError && action.callbackError(resp?.data);
    }
  } catch (e) {
    action && action.callbackError && action.callbackError(e && e?.data ? e?.data : e);
  }
}

export function* getEmployeeLeaveBalanceSaga(action) {
    try {
        const { token, data: { employeeId, year } } = action.payload;
        const resp = yield call(CallApi.POST, `${API_URLS.USERS.LEAVES.LEAVES_BALANCE}/${employeeId}`, { year }, token)
        if (resp && resp?.status && resp.status >= 200 && resp.status < 300 && resp?.data && resp?.data?.success) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data);
        }
    } catch (e) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}